export const firebaseConfig = {
  apiKey: "AIzaSyAF0ixKrukUjN7XnETJieygHxGFXW0M6Bk",
  authDomain: "vue-to-do-4fa82.firebaseapp.com",
  databaseURL: "https://vue-to-do-4fa82.firebaseio.com",
  projectId: "vue-to-do-4fa82",
  storageBucket: "vue-to-do-4fa82.appspot.com",
  messagingSenderId: "620060105724",
  appId: "1:620060105724:web:a699ea67cf75948ab07079",
};
